module.exports = __webpack_public_path__ + "img/PD1503651468614438912.13fb39d0.png";